import React from 'react'

import Select from 'Components/Select'

export default class ComboSimple extends React.Component {
  constructor (props) {
    super(props)
  }

  render () {
    return (
      <Select style={this.props.style}
              inline={this.props.inline}
              inlineWidth={this.props.inlineWidth}
              title={this.props.title}
              disabled={this.props.disabled || false}
              options={this.props.options}
              onChange={this.props.onChange}
              inputStyle={this.props.inputStyle || {padding: 0}}
              value={this.props.infoTiers === true && this.props.data !== undefined ? this.props.data.id : this.props.data}/>
    )
  }
}



// WEBPACK FOOTER //
// ./app/Utilitaire/Component/Utilitaire/ComboSimple/ComboSimple.js